import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { AuthGuard } from 'app/auth/auth.guard';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatBadgeModule} from '@angular/material/badge';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSortModule} from '@angular/material/sort';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import { SurveyStatusV2Component } from './survey-status-v2.component';
import { MenuComponent } from './menu/menu.component';
import { ContenidoComponent } from './contenido/contenido.component';
import { AccionesComponent } from './contenido/acciones/acciones.component';
import { DetallesComponent } from './detalles/detalles.component';
import { ColaboradoresComponent } from './contenido/colaboradores/colaboradores.component';
import { ModalComponent } from './contenido/colaboradores/modal/modal.component';
import { SurveyCheckComponent } from './contenido/acciones/survey-check/survey-check.component';

import { NuevoColaboradorModule } from "./contenido/colaboradores/nuevo-colaborador/nuevo-colaborador.module";
import { LogEmailsComponent } from './contenido/log-emails/log-emails.component';
import { ModalComponent as ModalComponentLogMail } from './contenido/log-emails/modal/modal.component';
import { ModalComponent as ModalComponentAcciones } from './contenido/acciones/modal/modal.component';
import { AuditoriaComponent } from './contenido/auditoria/auditoria.component';
import { VizualizadorEmailsComponent } from './contenido/vizualizador-emails/vizualizador-emails.component';
import { ModalesComponent } from './contenido/vizualizador-emails/modales/modales.component';
import { ChartsModule } from 'ng2-charts';
import { StylePaginatorDirective } from './contenido/auditoria/style-paginator.directive';
import { EditorModule as ModMCE } from '@tinymce/tinymce-angular';

const rutas = [
  {
    path     : 'companies/survey-status/:id',
    component: SurveyStatusV2Component,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [SurveyStatusV2Component, MenuComponent, ContenidoComponent, AccionesComponent, DetallesComponent, ColaboradoresComponent, ModalComponent, SurveyCheckComponent, LogEmailsComponent, ModalComponentLogMail, ModalComponentAcciones, AuditoriaComponent, VizualizadorEmailsComponent, ModalesComponent,StylePaginatorDirective],
  imports: [
    CommonModule,
    ModMCE,
    RouterModule.forChild(rutas),
    TranslateModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatCardModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatStepperModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatSidenavModule,
    NuevoColaboradorModule,
    ChartsModule,
    MatExpansionModule,
    MatSortModule
  ],
  entryComponents: [ModalComponent, SurveyCheckComponent, ModalComponentLogMail, ModalComponentAcciones]
})
export class SurveyStatusV2Module { }
